var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.830078,
    width: 40.4286,
    height: 39,
    rx: 5.5,
    fill: "#FFF8F5",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1048 16.6113C27.6465 19.153 27.6465 23.278 25.1048 25.8196C22.5632 28.3613 18.4382 28.3613 15.8965 25.8196C13.3548 23.278 13.3548 19.153 15.8965 16.6113C18.4382 14.0697 22.5632 14.0697 25.1048 16.6113Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.5931 30.8718C14.5098 30.0384 12.6869 28.528 11.4785 26.4342C10.291 24.3822 9.89521 22.1009 10.1765 19.9238",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.0938 12.9974C15.8646 11.612 18.0833 10.7891 20.5 10.7891C22.8646 10.7891 25.0417 11.5911 26.7917 12.9245",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.4062 30.8718C26.4896 30.0384 28.3125 28.528 29.5208 26.4342C30.7083 24.3822 31.1042 22.1009 30.8229 19.9238",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon4);
export default __webpack_public_path__ + "static/media/feature-icon-4.d620d3777458fb6426ad8550c02c8d8d.svg";
export { ForwardRef as ReactComponent };